import { Device } from '../appTypings';

export const isVestel2017 =
  typeof window !== 'undefined' &&
  /vestel.+2017/i.test(window.navigator.userAgent);

export const isDesktopDevelopment = (device: Device | undefined): boolean =>
  device?.family === 'development';

export const isLg2017 = (device: Device | undefined): boolean => {
  const { vendor, year } = device || {};
  return vendor === 'LGE' && year !== undefined && parseInt(year, 10) < 2018;
};

export const isTeliaDevice = (device: Device | undefined): boolean => {
  const { model } = device || {};
  return model === 'VIP5305' || model === 'VIP4302';
};

export const isPS4Device = (device: Device | undefined): boolean => {
  const { model, family } = device || {};
  return model === 'PS4' && family === 'native';
};

export const isSamsungDevice = (device: Device | undefined): boolean => {
  const { vendor, family } = device || {};
  return vendor === 'Samsung' && family === 'native';
};

export const isOldPanasonic = (device: Device | undefined): boolean => {
  const { vendor, year } = device || {};
  return vendor === 'Panasonic' && (year === '2017' || year === '2018');
};
